import Chip from "components/Elements/Chip";
import React from 'react';
import { SegmentStatus } from "types/Segment";

const statusStyles = {
  [SegmentStatus.Completed]: "",
  [SegmentStatus.InProgress]: "!bg-blue-200 !text-blue-600",
  [SegmentStatus.Failed]: "!bg-red-200 !text-red-600",
  [SegmentStatus.Draft]: "!bg-gray-200 !text-gray-600",
};

interface SegmentStatusBadgeProps {
  status: SegmentStatus
}

const SegmentStatusBadge = ({ status }: SegmentStatusBadgeProps) => {
  return (
    <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
      <Chip
        wrapperClass={`${statusStyles[status]} w-full`}
        label={status}
      />
    </td>
  )

}

export default SegmentStatusBadge